import { cn } from "@/lib/utils";

const STYLES = {
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
  fresh: "bg-emerald-50 text-emerald-700 border-emerald-200",
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  on_time: "bg-emerald-50 text-emerald-700 border-emerald-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  quarantined: "bg-amber-50 text-amber-800 border-amber-300 font-bold",
  stale: "bg-amber-50 text-amber-800 border-amber-300",
  pending: "bg-blue-50 text-blue-700 border-blue-200",
  received: "bg-blue-50 text-blue-700 border-blue-200",
  processing: "bg-blue-50 text-blue-700 border-blue-200 animate-pulse",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  failed: "bg-rose-50 text-rose-700 border-rose-200",
  late: "bg-rose-50 text-rose-700 border-rose-200",
  incomplete: "bg-rose-50 text-rose-700 border-rose-200",
  disabled: "bg-rose-50 text-rose-700 border-rose-200",
  duplicate: "bg-purple-50 text-purple-700 border-purple-200",
  unavailable: "bg-slate-100 text-slate-600 border-slate-300",
  missed: "bg-rose-50 text-rose-700 border-rose-200 font-bold",
  awaiting: "bg-blue-50 text-blue-700 border-blue-200",
  queued: "bg-slate-100 text-slate-600 border-slate-300",
  running: "bg-blue-50 text-blue-700 border-blue-200 animate-pulse",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  held: "bg-amber-50 text-amber-800 border-amber-300",
  unknown: "bg-slate-100 text-slate-600 border-slate-300",
  inactive: "bg-slate-100 text-slate-600 border-slate-300",
  admin: "bg-[#101C47] text-white border-[#101C47]",
  manager: "bg-indigo-50 text-indigo-700 border-indigo-200",
  employee: "bg-slate-100 text-slate-700 border-slate-300",
};

export function StatusBadge({ status, label, className, testId }) {
  const key = (status || "unknown").toString().toLowerCase();
  return (
    <span data-testid={testId || `status-badge-${key}`} className={cn("inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-[11px] font-medium uppercase tracking-wide whitespace-nowrap", STYLES[key] || STYLES.unknown, className)}>
      {label || key.replace(/_/g, " ")}
    </span>
  );
}
